import { styles, variants, NavigationListItemTheme } from '../NavigationListItemStyles.css';
import { baseTheme } from './CollapsibleNavigationListItemBaseTheme.css';
import { multiVariantStyles } from './CollapsibleNavigationListItemVariants.css';

const NavigationListItemRedwoodTheme: NavigationListItemTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

export { NavigationListItemRedwoodTheme };
